const TEST_IDS = {
  withdrawalRequestListItem:
    'vault-vault-item-withdraw-from-vesting-vault-modal-withdrawal-request-list-item',
};

export default TEST_IDS;
